import React from "react";
import { Router, Route, IndexRoute } from "react-router";
import { store, history } from "./store.js";
import App from "./components/App";
import Home from "./components/Home";
import Register from "./components/Register";
import Login from "./components/Login";
import NotFound from "./components/NotFound";
import InfoList from "./components/InfoList";
import Vendor  from "./components/Vendor";
import ZipCodeAssignment from "./components/ZipCodeAssignment";
import Lead from "./components/Lead";
import CUAssignToCloser from "./components/CUAssignToCloser";
import LeadReport from "./components/LeadReport";
import ActivationEmail from "./components/ActivationEmail";
import ActivationOrganization from "./components/ActivationOrganization";
import AssignStaff from "./components/AssignStaff";
import StaffReporting from "./components/StaffReporting";
import CUReporting from "./components/CUReporting";
import Approve from "./components/Approve";
import StaffToManager from "./components/StaffToManager";
import ManageUser from "./components/ManageUser";
//import ManageVendor from "./components/ManageVendor";
import ImportData from "./components/ImportData";
import Activities from "./components/Activities";
import AssignmentLogging from "./components/AssignmentLogging";
//import VendorRegister from "./components/VendorRegister.js";
import HealthPlans from "./components/HealthPlans.js";
import ROUTE from "./constants/routes";


const router = (
  <Router
    onUpdate={() => {
      window.scrollTo(0, 0);
      store.dispatch({
        type: "search_box_update",
        payload: "",
      });
    }}
    history={history}
  >
    <Route path="/" component={App}>
      <IndexRoute component={Home} />
      <Route path="dashboard" component={Home} />
      <Route path="register" component={Register} />
      <Route path="login" component={Login} />
      <Route path="active-email" component={ActivationEmail} />
      <Route path="active-vendor" component={ActivationOrganization} orgtype="vendor"/>
      {/*<Route path="active-clinic" component={ActivationOrganization} orgtype="Clinic"/>
      <Route path="active-driver" component={ActivationOrganization} orgtype="Driver"/>*/}
      <Route path={ROUTE.INFO_DASHBOARD} component={InfoList} />
      <Route path={ROUTE.LEAD_GENERATOR_DASHBOARD} component={InfoList} />
      <Route path={ROUTE.VENDOR_DASHBOARD} component={Vendor} />
      {/*<Route path={ROUTE.CLINIC_DASHBOARD} component={Clinic} />
      <Route path={ROUTE.DRIVER_DASHBOARD} component={Driver} />*/}
      <Route path="imported-data" component={InfoList} />
      <Route path={ROUTE.LEAD_DASHBOARD} component={Lead} />
      <Route path={ROUTE.ASSIGN_TO_CLOSER} component={CUAssignToCloser} />
      <Route path={ROUTE.ASSIGNED_CLOSER} component={CUAssignToCloser} />
      <Route path={ROUTE.WAIT_LIST} component={CUAssignToCloser} />
      {/*<Route path={ROUTE.ASSIGN_TO_CLOSER} component={CUAssignToCloser} />*/}
      <Route path={ROUTE.ASSIGN_TO_VENDOR} component={CUAssignToCloser} />
      <Route path={ROUTE.ASSIGNED_VENDOR} component={CUAssignToCloser} />
      <Route path={ROUTE.SERVICE_PENDING} component={CUAssignToCloser} />
      <Route path="lead-report" component={LeadReport} />
      <Route path="approve" component={Approve} />
      <Route path="zipcodeassigment" component={ZipCodeAssignment} />
      <Route path="assign-staff" component={AssignStaff} />
      <Route path="staff-report" component={StaffReporting} />
      <Route path="cu-report" component={CUReporting} />
      <Route path="staff-to-manager" component={StaffToManager} />
      <Route path="manage-user" component={ManageUser} />
      <Route path="import-data" component={ImportData} />
      <Route path="staff-activities" component={Activities} />
      <Route path="assignment-logging" component={AssignmentLogging} />
      <Route path="health-plans" component={HealthPlans} />
      <Route path="*" component={NotFound} />
    </Route>
  </Router>
);

// export
export { router };



// WEBPACK FOOTER //
// ./client/router.js